<template>
  <div>
    <SettingsNavigation />

    <BaseWrapper>
      <PAYGChangePlansCard v-if="!isPerCandidate" />
    </BaseWrapper>
  </div>
</template>

<script>
import SettingsNavigation from '@components/Settings/SettingsNavigation'
import PAYGChangePlansCard from '@components/Plans/PAYGChangePlansCard'

import { mapGetters } from 'vuex'

/**
 * Per-candidate organisations have no plan to change; they are sent to the
 * pricing page, which holds the card on file.
 */
export default {
  components: {
    SettingsNavigation,
    PAYGChangePlansCard
  },

  computed: {
    ...mapGetters({
      isPerCandidate: 'organisations/isPerCandidate'
    })
  },

  watch: {
    isPerCandidate: {
      immediate: true,
      handler(value) {
        if (value) {
          this.$router.replace({ name: 'settings-payg-plan' })
        }
      }
    }
  }
}
</script>
